import { FindConnectCommand, FindFormatCommand, FindCssRenderCommand, FindMeasureCommand, FindScenariiCommand, FindStyleCommand, FreedataCall, GridsterWidget, PDF_PAGE_KIND, PDFPage, PhysicalTemplateCmd, PhysicalTemplateVO, TabVO, UserContextService, VisionStepPerimeterCommand, WIDGET_KIND, FindWorkComCommand, WorkcomCall, WidgetComponent, ColorPickerPop, StyleEngine } from '@wizeoo/akm-common-lib';
import { PermissionAccess, PermissionVisibility } from '@wizeoo/akm-common-lib';
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, ElementRef, HostListener, Renderer2, ViewChild } from '@angular/core';
import { WIZ_COMMAND_STATE, WIZ_EVENT_TYPE,  
  CONFIRMATION_MODE, CONFIRMATION_RESULT, WizMathUtils, WIZ_PHYSIC_POSITION, 
  VALUE_C,
  VALUE_V} from '@wizeoo/akm-core-lib';
import {
  ConfirmationResultObj,
  FilterComponent,
  WizDatasource,
  WizGroupCommand,
  WizIcon,
  WizPopUp,
  WizRoot,
  WizTranslationBasic,
  WizDropdown,
  BATCH_FILE_FORMAT,
  WizEventManager, WizEvent
} from '@wizeoo/akm-component-lib';
import { DisplayGrid, GridsterItem, GridsterItemComponent } from 'angular-gridster2';
import { cloneDeep, isEqual } from 'lodash-es';
import { MultiDisplayConfig } from '@wizeoo/akm-common-lib';
import { AgLabelValidityRenderer } from '@wizeoo/akm-common-lib';
import { AlkEvent } from '@wizeoo/akm-common-lib';
import { ALK_EVENT_TYPE} from '@wizeoo/akm-common-lib';
import { ViewData } from '@wizeoo/akm-common-lib';
import { ChronocodeCmd } from '@wizeoo/akm-common-lib';
import { StaticFeatureEnum } from '@wizeoo/akm-common-lib';
import { BaseView } from '@wizeoo/akm-common-lib';
import { BATCH_KIND } from '@wizeoo/akm-common-lib';
import { Model } from './../../model/model';
import { NewTabPop } from './../newtab/pop/new-tab.pop';
import { PhysicalTemplateCreationPop } from './pop/phys-template.create.pop';
import { FakeVO } from '@wizeoo/akm-common-lib';
import { EM_ACTION } from '@wizeoo/akm-compute-lib';
import { WidgetEmb } from '@wizeoo/akm-message-lib';
import { PhysicalTemplateEngine } from '@wizeoo/akm-common-lib';
import { ClipboardService } from 'ngx-clipboard';
import { WidgetBasic } from '@wizeoo/akm-common-lib';

@Component({
  selector: 'templating-view',
  templateUrl: './templating.view.html',
  styleUrls: ['./templating.view.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
/** gestion des modèles de vues et conversion en vues véritables, disponibles pour l'application */
export class TemplatingView extends BaseView {
  
  // copie de widget inter-templates
  @HostListener('window:keydown', ['$event'])
  keyEvent(event: KeyboardEvent) {
    
    if (event.key === VALUE_V && event.ctrlKey && !!ViewData.widgetCopy) {
      event.stopImmediatePropagation();
      event.preventDefault();
      this.cloneWidget(new AlkEvent(ALK_EVENT_TYPE.CLONE_WIDGET_REQUEST, ViewData.widgetCopy));
    }
  }    
  
  
  @ViewChild('btnCreate', { read: WizIcon, static: true }) btnCreate: WizIcon; // bouton d'ajout de template du multiDisplay
  @ViewChild('btnRemove', { read: WizIcon, static: true }) btnRemove: WizIcon; // bouton de suppression de template du multiDisplay
  @ViewChild('btnExport', { read: WizIcon, static: true }) btnExport: WizIcon; // bouton d'export
  @ViewChild('btnImport', { read: WizIcon, static: true }) btnImport: WizIcon; // bouton d'import
  @ViewChild('taDescription', { read: WizTranslationBasic }) taDescription: WizTranslationBasic; // description
  @ViewChild('ddScreenMode', { read: WizDropdown }) ddScreenMode: WizDropdown; // mode de rendu pour conf gridster

  /** couleur de fond */
  @ViewChild('blockBack') blockBack: ElementRef; // zone de dessin de la couleur de background

  private templateDS: WizDatasource<PhysicalTemplateVO> = new WizDatasource<PhysicalTemplateVO>([])
    // .setFilter(this._mainFilterFunc.bind(this))
    .setSortFields([{ property: 'trsLabel', way: 'asc', numeric: false }])
    .build(); // la collection de PhyTVO pour alimentation du grid

  public screenModeDS: WizDatasource<FakeVO> = new WizDatasource<FakeVO>([...ViewData.getInstance().screenModes])
    .setSortFields([{ property: 'order', way: 'asc', numeric: false }])
    .build(); 

  private _currentTemplate: PhysicalTemplateVO = null; // template en cours d'édition (source)
  public get clone(): PhysicalTemplateVO {
    return Model.getInstance().workingTemplateClone;
  }
  // public clone: PhysicalTemplateVO = null; // clone du template pour modifications, public car référencé dans le compo gridster

  /**
   * sélection du template dans la liste
   * @param value: PhysicalTemplateVO
   */
  public set currentTemplate(value: PhysicalTemplateVO) {
    
    // rincer le filtre éventuel dans le menu
    WizEventManager.dispatchEvent(WizRoot.root(), new AlkEvent(ALK_EVENT_TYPE.GLOBAL_FILTER_CLEAR));

    if (value !== this.currentTemplate) {
      this._currentTemplate = value;
      if (this._currentTemplate) {
        Model.getInstance().workingTemplateClone = Model.getInstance().physicalTemplateEngine.clone(this._currentTemplate); // alimentation du clone

        this.widgets = Model.getInstance().workingTemplateClone.widgets; // alimentation des widgets de gridster

        // alimentation de la map de widget de l'engine
        Model.getInstance().widgetEngine.widgetConfigMap = new Map(this.widgets.map((gw: GridsterWidget) => [gw.uid, gw]));

        this.taDescription.translationData = Model.getInstance().localeEngine.buildTranslationData(
          Model.getInstance().workingTemplateClone.descriptionVO
        );

        // couleur des barres de menu
        if (!!this._currentTemplate.color) {
          this.backgroundColor = this._currentTemplate.color;
        } else {
          this.backgroundColor = StyleEngine.STYLE_DEFAULT_VIEW_BACKGROUND_COLOR;
        }

        let smCode: any = this._currentTemplate.screenMode;
        if(!smCode) {
          smCode = ViewData.DEFAULT_SCREEN_MODE;
        }
        let smItem: FakeVO = this.screenModeDS.getItemByKey(smCode);
        this.screenModeDS.select([smItem]);

        this.applyGridsterConfig(); // définition du type de rendu gridster
      } else {
        Model.getInstance().workingTemplateClone = null; // alimentation du clone
        this.widgets = null; // alimentation des widgets de gridster
        this.taDescription.translationData = null;
      }

      this.cdref.markForCheck();
    }
  }
  public get currentTemplate(): PhysicalTemplateVO {
    return this._currentTemplate;
  }

  /** Indique si un template est en cours d'édition, utilisé pour switcher le template de vue détail */
  get hasCurrentTemplate(): boolean {
    return !!this._currentTemplate;
  }

  /** indicateur pas de changement pour btnSave */
  public noUpdate(): boolean {
    // console.log('noUpdate', ViewData.wizUpdateModel);
    return ViewData.wizUpdateModel === false;
  }

  /** indicateur pas de widgets */
  public noWidget(): boolean {
    let result: boolean = false; // on part du principe qu'il y a des widgets
    if (!this._currentTemplate) {
      // pas de template
      result = true;
    }
    if (this.currentTemplate && !this.currentTemplate.hasWidget()) {
      // console.log('nowidget', this.currentTemplate.hasWidget() );
      result = true;
    }
    if (!this.noUpdate()) {
      // un update en cours, le valider d'abord
      result = true;
    }
    return result;
  }

  /** Indique si une vision est sélectionnée, sinon, pas de Add */
  get canCreate(): boolean {
    return (
      Model.getInstance().visionCode &&
      Model.getInstance().visionCode.length > 0 &&
      Model.getInstance().permissionEngine.canCreate(StaticFeatureEnum.TEMPLATE)
    );
  }

  // Options par défaut pour satisfaire GridSter
  public options: any = PhysicalTemplateEngine.gridsterSafe();

  // les widgets (leur carcasse gridster pour positionnement)
  public widgets: GridsterWidget[];

  // la map des widgets en cours

  private mainFilter: FilterComponent; // Référence au filtre contenu dans le composant multiDisplay

  /**
   * Configuration du multi display
   * Affichage uniquement d'un grid, on utilise le multi display pour profiter du filter component et des boutons d'actions
   */
  public multiConfig: MultiDisplayConfig<PhysicalTemplateVO> = {
    model: Model.getInstance(),
    datasource: this.templateDS,
    defaultMode: 'grid',
    onSelectionChanging: this.onSelectionChanging.bind(this),
    grid: {
      enabled: true,
      columns: [
        { field: 'code', sortable: true, headerName: '$.common.code.$', resizable: true, width: 80 },
        {
          field: 'trsLabel',
          sortable: true,
          resizable: true,
          headerName: '$.common.label.$',
          width: 120,
          tooltipField: '$.common.label.$',
          cellRenderer: 'labelRenderer',
        },
        {
          field: 'trsDesc',
          sortable: true,
          resizable: true,
          width: 200,
          headerName: '$.common.description.$',
          tooltipField: '$.common.description.$',
        },
      ],
      renderers: {
        labelRenderer: AgLabelValidityRenderer,
      },
    },
    filter: {
      enabled: true,
      initFilter: this.initFilter.bind(this),
    },
  };

  constructor(
    public elementRef: ElementRef,
    public renderer: Renderer2,
    private cdref: ChangeDetectorRef,
    private _clipboardService: ClipboardService
  ) {
    super(elementRef);
  }

  private get _context(): UserContextService {
    return Model.getInstance().userContextService;
  }

  wizBeforeInit() {
	super.wizBeforeInit();
    const calls = [];
    // tout le reste est chargé sur InitApp

    if (!Model.getInstance().chronocodeEngine.getChronocodesMap()) {
      // disponibilité des chronocodes pour labels
      calls.push(new ChronocodeCmd(Model.getInstance()).find());
    }
    if (!Model.getInstance().freedataEngine.getFreedataMap()) {
      calls.push(new FreedataCall(Model.getInstance()));
    }
    if (!Model.getInstance().measureEngine.getMeasureList()) {
      // vérification des measures
      calls.push(new FindMeasureCommand(Model.getInstance()));
    }
    if (!Model.getInstance().styleList) {
      // chargement de la liste des styles
      calls.push(new FindStyleCommand(Model.getInstance()));
    }
    if (!Model.getInstance().connectMapExt) {
      // chargement de la liste des fonctions de connexion
      calls.push(new FindConnectCommand(Model.getInstance()));
    }

    // disponibilité des scenarii
    if (!Model.getInstance().scenariiMap) {
      calls.push(new FindScenariiCommand(Model.getInstance()));
    }

    // chargement de la liste des formats
    if (!Model.getInstance().formatEngine.getFormatList()) {
      // double appel pour format de base à la bu (*)
      calls.push(new FindFormatCommand(Model.getInstance()).find(ViewData.wildcardDomain, ViewData.wildcardDomain));
      calls.push(new FindFormatCommand(Model.getInstance()).find(Model.getInstance().domainCode, Model.getInstance().businessUnitCode));
    }

    // chargement de la liste des rendus css
    if (!Model.getInstance().styleEngine.getCssRenderList()) {
      calls.push(new FindCssRenderCommand(Model.getInstance()).find(Model.getInstance().domainCode, Model.getInstance().businessUnitCode));
    }

    // vsp pas encore chargés
    if (!!Model.getInstance().currentVision && !Model.getInstance().visionEngine.getStepPerimeterList(Model.getInstance().currentVision)) {
      calls.push(new VisionStepPerimeterCommand(Model.getInstance()).find(Model.getInstance().currentVision, true));
    }

    // chargement des messages
    if (!Model.getInstance().workflowEngine.getWorkcomMap()) {
      calls.push(new WorkcomCall(Model.getInstance()));
    }

    // if (!Model.getInstance().workcomList) {
    //   calls.push(new FindWorkComCommand(Model.getInstance()));
    // }

    calls.push(new PhysicalTemplateCmd(Model.getInstance()).find());
    return new WizGroupCommand().configure(calls);
  }

  wizAddListener() {
    super.wizAddListener();

    WizEventManager.addListener(this, this, WIZ_EVENT_TYPE.DELETE, this.deleteWidget); // demande de suppression d'un widget
    // WizEventManager.addListener(this, this, WIZ_EVENT_TYPE.CHANGE, this.onItemChange); // selectionChange sur conf widgets
    WizEventManager.addListener(this, this.taDescription, WIZ_EVENT_TYPE.MODEL_UPDATE, this.onDescChange); // modif de la description
    WizEventManager.addListener(this, WizRoot.root(), ALK_EVENT_TYPE.SELECT_VISION, this.feedDatas); // modification de la portée vision au niveau de l'appli, rechargement
    WizEventManager.addListener(this, this.elementRef, ALK_EVENT_TYPE.CHECK_SLAVE_INTEGRITY, this.checkSlavesIntegrity); // contrôle de l'intégrité des esclaves

    WizEventManager.addListener(this, this, ALK_EVENT_TYPE.WIDGET_CONFIG_UPDATE, this.onConfigChange); // selectionChange sur conf widgets
    WizEventManager.addListener(this, WizRoot.root(), ALK_EVENT_TYPE.BATCH_IMPORT_RETURN, this.backFromImport);

    // changement de mode de rendu gridster
    WizEventManager.addListener(this, this.ddScreenMode, WIZ_EVENT_TYPE.SELECTION_CHANGED, this.setGridsterMode);

    // demande de clonage de widget
    WizEventManager.addListener(this, this.elementRef, ALK_EVENT_TYPE.CLONE_WIDGET_REQUEST, this.cloneWidget);

    WizEventManager.addListener(this, WizRoot.root(), ALK_EVENT_TYPE.PDF_PRINT_REQUEST, this.generatePDF);
  }

  wizRemoveListener() {
    super.wizRemoveListener();

    WizEventManager.removeListener(this, this, WIZ_EVENT_TYPE.DELETE);
    // WizEventManager.removeListener(this, this, WIZ_EVENT_TYPE.CHANGE);
    WizEventManager.removeListener(this, this.taDescription, WIZ_EVENT_TYPE.MODEL_UPDATE);
    WizEventManager.removeListener(this, WizRoot.root(), ALK_EVENT_TYPE.SELECT_VISION);
    WizEventManager.removeListener(this, this.elementRef, ALK_EVENT_TYPE.CHECK_SLAVE_INTEGRITY);

    WizEventManager.removeListener(this, this, ALK_EVENT_TYPE.WIDGET_CONFIG_UPDATE); // selectionChange sur conf widgets
    WizEventManager.removeListener(this, WizRoot.root(), ALK_EVENT_TYPE.BATCH_IMPORT_RETURN);

    WizEventManager.removeListener(this, this.ddScreenMode, WIZ_EVENT_TYPE.SELECTION_CHANGED);
    WizEventManager.removeListener(this, this.elementRef, ALK_EVENT_TYPE.CLONE_WIDGET_REQUEST);

    WizEventManager.removeListener(this, WizRoot.root(), ALK_EVENT_TYPE.PDF_PRINT_REQUEST);
  }

  wizSynchronizeData() {
    super.managePermissions([
      {
        feature: StaticFeatureEnum.TEMPLATE,
        permissions: [
          {
            component: this.btnCreate,
            accesses: [PermissionAccess.CREATE],
            visibility: PermissionVisibility.DISABLED,
          },
          {
            component: this.btnRemove,
            accesses: [PermissionAccess.DELETE],
            visibility: PermissionVisibility.DISABLED,
          },
          {
            component: this.btnExport,
            accesses: [PermissionAccess.BATCH],
            visibility: PermissionVisibility.DISABLED,
          },
          {
            component: this.btnImport,
            accesses: [PermissionAccess.BATCH],
            visibility: PermissionVisibility.DISABLED,
          },
        ],
      },
    ]);

    // options de configuration de gridster (toutes les options possibles)
    const opts = Model.getInstance().physicalTemplateEngine.gridsterOption();
    // template de base pour le gridster
    opts.displayGrid = DisplayGrid.Always;
    opts.minCols = 50;
    opts.minRows = 50;
    opts.itemChangeCallback = this.onItemMovedOrResized.bind(this); // détection d'un changement de position
    opts.resizable.enabled = this.canUpdateTemplates;
    opts.draggable.enabled = this.canUpdateTemplates;
    opts.itemResizeCallback =  (item: GridsterItem, itemComponent: GridsterItemComponent) => {this.onItemResize(item, itemComponent)};
    this.options = opts;
      
    this.buildFilter();
    this.feedDatas(); // alimentation des DS
    
  }

  /**
   * écoute du resize sur le gridster item pour transmission au widget (pour resize de la barre de filtre)
   * @param item 
   * @param itemComponent 
   */
  private onItemResize(item: GridsterItem, itemComponent: GridsterItemComponent) {
    const el = (item.instance as WidgetBasic)?.elementRef.nativeElement;
    if(!!el) {
      const rect = el.getBoundingClientRect();
      (item.instance as WidgetBasic).onResize(rect.width, rect.height);
      // console.log('resize live', rect.width, rect.height, itemComponent);
    }

  }

  private applyGridsterConfig(): void { 
    // en mode templating, on utilise uniquement le rendu fixe
    this.options.gridType = ViewData.TEMPLATE_SCREEN_MODE;
    // this.options.gridType = Model.getInstance().workingTemplateClone?.screenMode || ViewData.DEFAULT_SCREEN_MODE;
    // console.log('applyGridsterConfig', this.options.gridType);
    this.options.api.optionsChanged();
  }


  /**
   * L'utilisateur a-t-il les droits pour modifier les templates ?
   */
  public get canUpdateTemplates(): boolean {
    return Model.getInstance().permissionEngine.hasAnyPermission({
      accesses: [PermissionAccess.CREATE, PermissionAccess.UPDATE],
      feature: StaticFeatureEnum.TEMPLATE,
      visibility: PermissionVisibility.DISABLED
    });
  }

  public wizOnDestroy(): void {
	super.wizOnDestroy();
    // this._context.saveLocalFilter(this.mainFilter);
  }

  /**
   * Init filter, élément donné par le multiDisplay component
   * @param pFilter le composant de filtre du multiDisplay
   */
  private initFilter(pFilter: FilterComponent): FilterComponent {
    this.mainFilter = pFilter;
    return this.mainFilter;
  }

  /** modif sur la description du template */
  private onDescChange(e: WizEvent): void {
    Model.getInstance().workingTemplateClone.descriptionVO.updateTranslationEntry(e.value);
    ViewData.wizUpdateModel = true;
  }

  /**
   * construction de la zone de filtre des templates
   * @param event : Evenement de changement dans le text input de filtre
   */
  private buildFilter(): void {
    this.mainFilter.configure(['code', 'trsLabel', 'trsDesc'], null, null);
    // le contextEngine prend le relais pour alimenter les filtres par défaut
    this._context.feedFilterContext(this.mainFilter);
  }

  /** déplacement ou resize d'un widget */
  protected onItemMovedOrResized(item, itemComponent) {
    // console.log('onItemMovedOrResized', item);
    this.onConfigChange(new AlkEvent(ALK_EVENT_TYPE.WIDGET_CONFIG_UPDATE, item));
    // this.onItemChange(new WizEvent(null, null, item));

    // calcul des indices. Va dispatcher un event pour maj éventuelle des entêtes de widgets
    Model.getInstance().physicalTemplateEngine.resetIndices(this.widgets);
  }


  /** demande de changement de sélection */
  private onSelectionChanging(e: WizEvent = null): void {
    const vo: PhysicalTemplateVO = e.value;
    if (ViewData.wizUpdateModel) {
      if (this.templateDS.isSelected(vo)) {
        // sélection self, rien
        e.preventDefault();
        return;
      }
      e.preventDefault(); // sélection pas self && modifs en cours

      WizPopUp.confirm(
        '$.common.pending.update.title.$',
        '$.common.pending.update.detail.$',
        this.confirmSelect.bind(this),
        CONFIRMATION_MODE.CONFIRM_CANCEL,
        vo
      ).show();
    } else {
      if (!this.templateDS.isSelected(vo)) {
        // pas encore sélectionné
        this.doSelect(vo);
      } else {
        this.doSelect(null);
        // e.preventDefault();
      }
    }
  }

  /** Confirmation de la sélection de la clé */
  private confirmSelect(result: ConfirmationResultObj): void {
    if (result.result === CONFIRMATION_RESULT.CONFIRM) {
      ViewData.wizUpdateModel = false;
      this.templateDS.toggle(result.data); // on a prevent l'event, on joue l'action
      this.doSelect(result.data);
    }
  }

  /**
   * changement de sélection de template
   * @param e wiZevent
   */
  private doSelect(phyt: PhysicalTemplateVO): void {
      this.currentTemplate = phyt; // va créer le clone et alimenter gridster
      // calcul des indices. Va dispatcher un event pour maj éventuelle des entêtes de widgets
      Model.getInstance().physicalTemplateEngine.resetIndices(this.widgets);
   }



  /**
   * alimentation des données "visions" sur synchronize ET changement global de vision
   * @param e alkevent, inutile
   */
  private feedDatas(e: AlkEvent = null): void {
    
    // alimentation de la datasource de templates
    this.templateDS.setSource(Model.getInstance().physicalTemplateEngine.getVisionTemplates(Model.getInstance().visionCode));
    this.templateDS.clearSelection();
    this.templateDS.refresh();
    super.managePermissions([
      {
        feature: StaticFeatureEnum.TEMPLATE,
        permissions: [
          {
            component: this.btnCreate,
            accesses: [PermissionAccess.CREATE],
            visibility: PermissionVisibility.DISABLED
          },
          {
            component: this.taDescription,
            accesses: [PermissionAccess.CREATE, PermissionAccess.UPDATE],
            visibility: PermissionVisibility.DISABLED
          }
          /*,
          {
            component: this.vgDetailZone,
            accesses: [PermissionAccess.READ, PermissionAccess.CREATE, PermissionAccess.UPDATE],
            visibility: PermissionVisibility.DISABLED
          },*/
          // {
          //   component: this.btnRemove,
          //   accesses: [PermissionAccess.DELETE],
          //   visibility: PermissionVisibility.DISABLED,
          // },
        ],
      },
    ]);

    this.currentTemplate = null; // pas de sélection
    this.widgets = []; // alimentation des items gridster, vide
    
    this.cdref.markForCheck();
  }

  /** Click sur le bouton de création */
  private onCreateClicked(): void {
    const pop: WizPopUp = new WizPopUp(
      PhysicalTemplateCreationPop,
      true,
      false,
      WIZ_PHYSIC_POSITION.MIDDLE_CENTER,
      '400px',
      '400px',
      undefined
    );
    pop.setCallback(this.onPhyTCreated.bind(this));
    pop.show();
  }

  /**
   * Retour de création d'un template
   * @param phyT le template persisté (retour de BDD)
   */
  onPhyTCreated(phyT: PhysicalTemplateVO): void {
    this.templateDS.addItem(phyT);
    // this.templateDS.refresh();
    this.templateDS.select([phyT]);
    this.currentTemplate = phyT;
    this.cdref.markForCheck();
  }

  /** icone suppression dispo */
  public canRemove(): boolean {
    return !!this.currentTemplate && this.currentTemplate.exists && Model.getInstance().permissionEngine.canDelete(StaticFeatureEnum.TEMPLATE);
  }


  /** Demande de suppression d'un template  */
  public doAskForRemove(): void {
    if (this._currentTemplate) {
      WizPopUp.confirm(
        '$.common.delete.title.$',
        '$.common.delete.detail.$',
        this.doRemovePhysicalTemplate.bind(this),
        CONFIRMATION_MODE.CONFIRM_CANCEL,
        this._currentTemplate,
        null
      ).show();
    }
  }

  /**
   * Suppression de modèle
   * @param result resultat de l'action sur la pop de confirmation de suppression
   */
  private doRemovePhysicalTemplate(result: ConfirmationResultObj): void {
    if (result.result === CONFIRMATION_RESULT.CONFIRM) {
      const temp: PhysicalTemplateVO = result.data;
      if (temp && temp.exists) {
        Model.getInstance().physicalTemplateEngine.remove(temp, this.removePhysicalTemplateCallback.bind(this));
      }
    }
  }

  /* ################################################
                      gestion des widgets
    ################################################ */

  /**
   * Callback de suppression de modèle
   *  @param cmd WizCommand
   */
  private removePhysicalTemplateCallback(bddPersist: PhysicalTemplateVO, status: string): void {
    if (status === WIZ_COMMAND_STATE.SUCCESS) {
      this.templateDS.removeItem(bddPersist);
      // Si suppression du modèle dans le panneau detail, reset
      if (bddPersist.code === this._currentTemplate.code) {
        this._currentTemplate = undefined;
      }
      // Affiche un toast de succès
      // WizPopUp.toast('$.template.toast.remove.success.$', WizIcon.TOAST_SUCCESS).show();
      this.cdref.markForCheck();
    }
  }

  /* ################################################
                      gestion des widgets
    ################################################ */

  /**
   * Ajout d'un nouveau widget dans le grid
   */
  public addWidget(): void {
    // on récupère la position suivante possible
    const nextGridsterItem: GridsterItem = this.options.api.getFirstPossiblePosition({ x: 0, y: 0, cols: 30, rows: 20 });
    const newItem: GridsterWidget = GridsterWidget.constructFromGridster(Model.getInstance(), nextGridsterItem);
    // push dans la liste du dash
    this.widgets.push(newItem);
    // ajout à la map de widgets
    Model.getInstance().widgetEngine.alterWidgetConfigMap(EM_ACTION.CREATE, newItem.uid, newItem); // a ce stade, pas de wco
    // WidgetEngine.widgetConfigMap.set(newItem.uid, newItem); // a ce stade, pas de wco

    // mise à jour du template via son clone
    Model.getInstance().workingTemplateClone.widgets = this.widgets;

    // calcul des indices. Va dispatcher un event pour maj éventuelle des entêtes de widgets
    Model.getInstance().physicalTemplateEngine.resetIndices(this.widgets);

    this.cdref.markForCheck();
  }
  /** Déclenchement de la mise à jour du template */
  public doSaveWidget() {
    if (this.widgets) {
      
      let toDie: GridsterWidget[]= [];
      
      this.widgets.forEach((agi: GridsterWidget) => {
        if (!!agi.wco) {
          // le template a bien un type
          if (!agi.wco.tv) {
            agi.wco.tv = 0;
          }
          agi.wco.tv++; // montée de version pour synchro des tabs
         } else {
          //   // console.log('no type', agi);
          toDie.push(agi);
          //   this.widgets.splice(this.widgets.indexOf(agi), 1);
        }
      });

      toDie.forEach((agi: GridsterWidget) => {
        this.widgets.splice(this.widgets.indexOf(agi), 1);
      });
    }  

    Model.getInstance().workingTemplateClone.widgets = this.widgets;

    Model.getInstance().physicalTemplateEngine.merge(
      Model.getInstance().workingTemplateClone,
      this._currentTemplate,
      (vo: PhysicalTemplateVO) => {
        this.currentTemplate = Model.getInstance().physicalTemplateEngine.getTemplate(vo.code);
        Model.getInstance().workingTemplateClone = Model.getInstance().physicalTemplateEngine.clone(this._currentTemplate);
        this.templateDS.itemUpdated([this.currentTemplate]);
        ViewData.wizUpdateModel = false;
        this.cdref.markForCheck();
      }
    );
  }

  /**
   * Suppression d'un widget du grid
   * @param pEvent ??
   */
  private deleteWidget(pEvent: WizEvent): void {
    this.widgets.splice(this.widgets.indexOf(pEvent.value), 1);
    Model.getInstance().physicalTemplateEngine.resetIndices(this.widgets); // calcul des indices. Va dispatcher un event pour maj éventuelle des entêtes de widgets
    Model.getInstance().workingTemplateClone.widgets = this.widgets;
    ViewData.wizUpdateModel = true;

    // suppression la map de widgets
    // WidgetEngine.widgetConfigMap.delete(pEvent.value.uid);
    Model.getInstance().widgetEngine.alterWidgetConfigMap(EM_ACTION.DELETE, pEvent.value.uid); // a ce stade, pas de wco
    // contrôle de la cohérence des widgets asservis
    WizEventManager.dispatchEvent(this, new AlkEvent(ALK_EVENT_TYPE.CHECK_SLAVE_INTEGRITY, this.widgets));

    // PhysicalTemplateManager.resetIndices(this.widgets);
    this.cdref.markForCheck();
  }

  /** modif de la conf du widget sur vue templating */
  private onConfigChange(pEvent: AlkEvent): void {
    // console.log('onConfigChange', pEvent);
    
    if (!Model.getInstance().workingTemplateClone) { // on avait rien, c'est l'init ?
      Model.getInstance().workingTemplateClone = new PhysicalTemplateVO(Model.getInstance());
    }

    // synchro source (x, y, rows, cols)
    const itemUpdated: GridsterWidget = pEvent.data;
    if(!!itemUpdated) {
      itemUpdated.updateCoords();
    }
    

    Model.getInstance().workingTemplateClone.widgets = this.widgets;
    const idx = this.widgets.indexOf(pEvent.value);
    WizEventManager.dispatchEvent(this, new AlkEvent(ALK_EVENT_TYPE.WIDGET_RESIZE, this)); // pour resize correct des charts

    // TODO déclenche un faux positif sur select du template
    if (this.currentTemplate) {
      let hasUpdate: boolean = !isEqual(this.currentTemplate.widgets, Model.getInstance().workingTemplateClone.widgets);
      ViewData.wizUpdateModel = hasUpdate;
    }
    this.cdref.markForCheck();
  }

  /* ################################################
                 création du Tab
    ################################################ */

  public convertToTab(): void {
    const pop: WizPopUp = new WizPopUp(
      NewTabPop,
      true,
      false,
      WIZ_PHYSIC_POSITION.MIDDLE_CENTER,
      '400px',
      '300px',
      { template: Model.getInstance().workingTemplateClone }
    );
    pop.setCallback(this.onTabCreated.bind(this));
    pop.show();
  }

  private onTabCreated(pTab: TabVO) {
    this.cdref.markForCheck();
  }



  /**
   * contrôle de cohérence des relations maitres-esclaves
   * @param e AlkEvent.CHECK_SLAVE_INTEGRITY
   */
  private checkSlavesIntegrity(e: AlkEvent): void {
    // console.log('checkSlavesIntegrity');
    this.widgets.forEach((givo: GridsterWidget) => {
      if(givo.wco?.k === WIDGET_KIND.GENERATOR) { // masters multiples sur generator
        // console.log('all ok checkSlavesIntegrity');
        let splitted: string[] = givo.masterUid?.split(ViewData.KEY_SEPARATOR) || [];
        if(splitted.length > 0) {
          let toLive: Set<string> = new Set();
          let toDie: Set<string> = new Set();
          let indices: string[] = [];
          
          splitted.forEach(s => {
            let gw: GridsterWidget = this.model.widgetEngine.getWidgetByUid(s);
            if(!!gw) {
              toLive.add(s);
              indices.push(gw.indice.toString());
            } else {
              toDie.add(s);
            }
          });
  
          if(toDie.size > 0) {
            givo.masterUid = toLive.size > 0 ? [...toLive.keys()].join(ViewData.KEY_SEPARATOR) : null;;
            WizEventManager.dispatchEvent(this, new AlkEvent(ALK_EVENT_TYPE.RESET_MASTER, givo));
          }
        } else {
          // pas de master sur le widget generator
        }
      }
      else {
        if(!givo.masterVO) { // master supprimé, reset
          givo.masterUid = null;
          WizEventManager.dispatchEvent(this, new AlkEvent(ALK_EVENT_TYPE.RESET_MASTER, givo));
        }
  
        if (givo.masterVO) {
          if (!!givo.freedataCode) { // widgets de type freedata
            if (givo.masterVO.freedataCode !== givo.freedataCode) { // plus le même FD
              givo.masterUid = null;
              WizEventManager.dispatchEvent(this, new AlkEvent(ALK_EVENT_TYPE.RESET_MASTER, givo));
            } else if (givo.masterVO.freedataLevel > givo.freedataLevel) { // plus profond
              givo.masterUid = null;
              WizEventManager.dispatchEvent(this, new AlkEvent(ALK_EVENT_TYPE.RESET_MASTER, givo));
            }
          } else {
              // pour chaque item possédant un master, on vérifie qu'il est valide... sinon, plus de master.
              if (givo.masterVO.wco.vs > givo.wco.vs) {
                // et il doit posséder un level <= au mien
                givo.masterUid = null;
                WizEventManager.dispatchEvent(this, new AlkEvent(ALK_EVENT_TYPE.RESET_MASTER, givo));
              }
          }
        }
      }

    });
  }

  public doAct(action: string): void {
    switch (action) {
      case 'export':
        Model.getInstance().batchEngine.export(BATCH_KIND.TEMPLATING, BATCH_FILE_FORMAT.JSON, Model.getInstance().visionCode);
        break;
      case 'import':
        Model.getInstance().batchEngine.import(BATCH_KIND.TEMPLATING);
        break;
      case 'create': // demande de create
          this.onCreateClicked();
      break;
    }
  }

  /** callback sur retour d'import : recharger les Freedatas */
  private backFromImport(e: AlkEvent): void {
	if (e && e.data === BATCH_KIND.TEMPLATING) {
      new PhysicalTemplateCmd(Model.getInstance()).find().configure(this.backFromReload.bind(this)).execute();
      new FindStyleCommand(Model.getInstance()).configure(this.backFromReload.bind(this)) .execute();
	} 
  }
 
   private backFromReload(e: any): void {
     this.wizSynchronizeData();
   } 

  /**
   * Indique si on peut utiliser les batchs
   * La vision doit être sélectionnée
   */
  public get canUseBatch(): boolean {
    return !(Model.getInstance().visionCode !== ViewData.wildcardDomain && Model.getInstance().visionCode.length > 0);
  }

  private setGridsterMode(e:WizEvent): void {
    let mode: FakeVO = this.ddScreenMode.selectedItem;
    Model.getInstance().workingTemplateClone.screenMode = mode.code;
    // console.log('mode', mode.code);
    ViewData.wizUpdateModel = true;
    this.applyGridsterConfig();
  }

  private cloneWidget(e: AlkEvent): void {
    let gridster: GridsterWidget = e.data;
    // console.log('cloneWidget', gridster);

    // on récupère la position suivante possible
    const nextGridsterItem: GridsterItem = this.options.api.getFirstPossiblePosition({ x: 0, y: 0, cols: gridster.cols, rows: gridster.rows });

    let widget: WidgetEmb = cloneDeep(gridster.source);
    widget.uid = WizMathUtils.createUUID();
    widget.x = nextGridsterItem.x;
    widget.y = nextGridsterItem.y;
    const newItem: GridsterWidget = new GridsterWidget(Model.getInstance(), widget);
    
    // push dans la liste du dash
    this.widgets.push(newItem);

    // ajout à la map de widgets
    Model.getInstance().widgetEngine.alterWidgetConfigMap(EM_ACTION.CREATE, newItem.uid, newItem); // a ce stade, pas de wco

    // mise à jour du template via son clone
    Model.getInstance().workingTemplateClone.widgets = this.widgets;

    // calcul des indices. Va dispatcher un event pour maj éventuelle des entêtes de widgets
    Model.getInstance().physicalTemplateEngine.resetIndices(this.widgets);

    ViewData.widgetCopy = null; // on rince la copie, sinon on peut jamais faire crtl-v

    this.cdref.markForCheck();
  }


  public generatePDF(e: AlkEvent): void {

    // console.log('utv', this.tabWidgets);
    let elements: PDFPage[] = [];
    let kind: PDF_PAGE_KIND;
    let isHeader: boolean = false;
    let noHead: boolean = false;
    let noFoot: boolean = false;
    let sorted: GridsterWidget[] = [...this.widgets.sort((a, b) => (a.y * 10000 + a.x) - (b.y * 10000 + b.x))];
    sorted.forEach(gw => {
      
      if( gw.instance.widgetKind === WIDGET_KIND.FD_GRID || 
          gw.instance.widgetKind === WIDGET_KIND.PIVOT || 
          gw.instance.widgetKind === WIDGET_KIND.GRID) {
        kind = PDF_PAGE_KIND.HTML;
      } else {
        kind = PDF_PAGE_KIND.IMAGE;
      }

      if(gw.title?.indexOf('header') > -1) {
        isHeader = true;
      } else {
        isHeader = false;
      }

      if(gw.title?.indexOf('noHead') > -1) {
        noHead = true;
      } else {
        noHead = false;
      }

      if(gw.title?.indexOf('noFoot') > -1) {
        noFoot = true;
      } else {
        noFoot = false;
      }


      let pdfPage: PDFPage = {element: gw.instance.elementRef, 
        widget: gw.instance,
        kind,
        isHeader,noHead, noFoot,
        width: gw.instance.elementRef.nativeElement.offsetWidth,
        height: gw.instance.elementRef.nativeElement.offsetHeight
      }
      elements.push(pdfPage);
    });
    
    this.model.excelExportEngine.pdfReport('allkeyme', elements);
  }

  /* ##############################################################################
                   gestion du colorPicker pour la conf du header
     ############################################################################## */

  public backgroundColor = StyleEngine.STYLE_DEFAULT_VIEW_BACKGROUND_COLOR; // --grid-header-background-color

  /**
   * affichage de la popUp du colorPicker
   * @param pEvent click
   */
  public showColorPicker(pEvent: Event): void {
    pEvent.stopPropagation();
    pEvent.preventDefault();
    ColorPickerPop.show(this.blockBack.nativeElement, pEvent.target, this.backgroundColor, this.backFromPicker.bind(this));
  }

  /**
   * retour de colorPicker, alimentation des couleurs du header
   *
   * @param target le span source pour font ou background
   * @param color la couleur du picker
   */
  public backFromPicker(target: any, color: string): void {
    this.backgroundColor = color;
    this.feedHeaderStyle();
  }

  /** alimentation des slots de couleurs pour le header */
  public feedHeaderStyle(): void {
    Model.getInstance().workingTemplateClone.color = this.backgroundColor;
    ViewData.wizUpdateModel = true;
    this.cdref.markForCheck();
  }

  /** click sur les icones de suppression de style de header */
  public resetColor(who: string): void {
    this.backgroundColor = 'unset'; 
    this.feedHeaderStyle();
  }


}
